type Props = {
  open: boolean;
  credentials: {
    username: string;
    password: string;
    serverPath: string;
    mountPoint: string;
  };
  onChange: (creds: Props["credentials"]) => void;
  onSubmit: () => void;
  status: string;
  error: string | null;
};

export default function NasLoginModal({ open, credentials, onChange, onSubmit, status, error }: Props) {
  if (!open) return null;
  const disabled =
    status === "mounting" || !credentials.mountPoint;
  return (
    <div className="modal-backdrop">
      <div className="modal" style={{ maxWidth: 600 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h3 style={{ margin: 0 }}>NAS Login</h3>
            <p style={{ margin: 0, color: "var(--text-muted)" }}>
              Mount the shared volume or point to an existing mount.
            </p>
          </div>
        </div>

        <div className="grid two" style={{ marginTop: 12 }}>
          <div>
            <div className="label">Username</div>
            <input
              className="input"
              required={false}
              value={credentials.username}
              onChange={(e) => onChange({ ...credentials, username: e.target.value })}
            />
          </div>
          <div>
            <div className="label">Password</div>
            <input
              className="input"
              type="password"
              required={false}
              value={credentials.password}
              onChange={(e) => onChange({ ...credentials, password: e.target.value })}
            />
          </div>
          <div style={{ gridColumn: "1 / -1" }}>
            <div className="label">Server Path (e.g. 10.0.0.2/share)</div>
            <input
              className="input"
              required={false}
              value={credentials.serverPath}
              onChange={(e) => onChange({ ...credentials, serverPath: e.target.value })}
              placeholder="Required when not already mounted"
            />
          </div>
          <div style={{ gridColumn: "1 / -1" }}>
            <div className="label">Mount point (e.g. /Volumes/data)</div>
            <input
              className="input"
              required
              placeholder="/Volumes/data or Z:\\nas"
              value={credentials.mountPoint}
              onChange={(e) => onChange({ ...credentials, mountPoint: e.target.value })}
            />
            <div className="label" style={{ marginTop: 4 }}>
              Mount point is required. Credentials + server path are needed only if it is not
              already mounted.
            </div>
          </div>
        </div>

        <div style={{ marginTop: 16, display: "flex", gap: 10, alignItems: "center" }}>
          <button className="button" onClick={onSubmit} disabled={disabled}>
            {status === "mounting" ? "Mounting…" : "Use NAS"}
          </button>
          {error && <span className="status-error">{error}</span>}
        </div>
      </div>
    </div>
  );
}
